import React, { useState, useMemo } from "react";
import Select from 'react-select'
import Application from "../../services/application.service";
import Helper from "../../helper";

const PersonalTwo = (props) => {
    let input = props.input
    const [country1, setCountry1] = useState('')
    const [country2, setCountry2] = useState('')

    useMemo(() => {
        console.log(input);
        if (input.country) setCountry1(Helper.findCountryByLabel(input.country));
        if (input.postal_country) setCountry2(Helper.findCountryByLabel(input.postal_country));
        if (input.is_postal_address === undefined) input.is_postal_address = 0;
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();

        input.country = (country1 !== null && country1 !== undefined && country1.label) ? country1.label : '';
        input.postal_country = (country2 !== null && country2 !== undefined && country2.label) ? country2.label : '';

        var formData = Helper.convertFormData(input);
        formData.append('step', 'person2');

        Application.applicationUpdate(formData).then(res => {
            if (res.success === true) {
                props.setFormCount(3);
            }
        }).catch(err => console.log(err));
    }

    return (
        <>
            <div className="form-wrapper">
                <div className='form-head'>
                    <h2>Enter Your Personal Details</h2>
                    <div className="sub-step-indicator">Step 2/3</div>
                </div>
                <div className="form-fields address">
                    <div className='row'>
                        <div className="col-12 form-group pt-3">
                            <label className="text-title" htmlFor="name">Street Address <span className="asterisk">*</span></label>
                            <div className="addrsess-fields pt-2">
                                <div className="row">
                                    <div className="col-lg-6 col-md-12 form-group">
                                        <div className="input-wrap d-flex">
                                            <input type="text" name="address_1" className="form-control" placeholder="Address Line 1" value={input.address_1} onChange={props.handleChange} />
                                        </div>
                                        <div className="validationAlert"></div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 form-group">
                                        <div className="input-wrap d-flex">
                                            <input type="text" name="address_2" className="form-control" placeholder="Address Line 2" value={input.address_2} onChange={props.handleChange} />
                                        </div>
                                        <div className="validationAlert"></div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 form-group">
                                        <div className="input-wrap d-flex">
                                            <input type="text" name="suburb" className="form-control" placeholder="Suburb" value={input.suburb} onChange={props.handleChange} />
                                        </div>
                                        <div className="validationAlert"></div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 form-group">
                                        <div className="input-wrap d-flex">
                                            <input type="text" name="city" className="form-control" placeholder="City" value={input.city} onChange={props.handleChange} />
                                        </div>
                                        <div className="validationAlert"></div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 form-group">
                                        <div className="input-wrap d-flex">
                                            <input type="text" name="postal_code" className="form-control" placeholder="Postal Code" value={input.postal_code} onChange={props.handleChange} />
                                        </div>
                                        <div className="validationAlert"></div>
                                    </div>
                                    <div className="col-lg-6 col-md-12 form-group">
                                        <div className="input-wrap d-flex">
                                            <Select name="country" options={props.countries} value={country1} onChange={setCountry1} placeholder={'Country'}></Select>
                                        </div>
                                        <div className="validationAlert"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 form-group form-check-alter">
                            <label className="text-title" htmlFor="name">Postal Address <span className="asterisk">*</span></label>
                            <div className="form-check p-0">
                                <div className="input-wrap">
                                    <input type="checkbox" className="form-check-input" id="exampleCheck1" name="is_postal_address" checked={input.is_postal_address} onChange={props.handleChecked} />
                                    <label className="form-check-label" htmlFor="exampleCheck1">Postal Address is same as Street Address</label>
                                </div>
                            </div>
                            {!input.is_postal_address &&
                                <div className="addrsess-fields pt-2">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-12 form-group">
                                            <div className="input-wrap d-flex">
                                                <input type="text" name="postal_address_1" className="form-control" placeholder="Address Line 1" value={input.postal_address_1} onChange={props.handleChange} />
                                            </div>
                                            <div className="validationAlert"></div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 form-group">
                                            <div className="input-wrap d-flex">
                                                <input type="text" name="postal_address_2" className="form-control" placeholder="Address Line 2" value={input.postal_address_2} onChange={props.handleChange} />
                                            </div>
                                            <div className="validationAlert"></div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 form-group">
                                            <div className="input-wrap d-flex">
                                                <input type="text" name="postal_suburb" className="form-control" placeholder="Suburb" value={input.postal_suburb} onChange={props.handleChange} />
                                            </div>
                                            <div className="validationAlert"></div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 form-group">
                                            <div className="input-wrap d-flex">
                                                <input type="text" name="postal_city" className="form-control" placeholder="City" value={input.postal_city} onChange={props.handleChange} />
                                            </div>
                                            <div className="validationAlert"></div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 form-group">
                                            <div className="input-wrap d-flex">
                                                <input type="text" name="postal_postal_code" className="form-control" placeholder="Postal Code" value={input.postal_postal_code} onChange={props.handleChange} />
                                            </div>
                                            <div className="validationAlert"></div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 form-group">
                                            <div className="input-wrap d-flex">
                                                <Select name="postal_country" options={props.countries} value={country2} onChange={setCountry2} placeholder={'Country'}></Select>
                                            </div>
                                            <div className="validationAlert"></div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="warning-msg"><span>*</span> Please note that you must fill the mandatory fields to submit the form.</div>
                </div>
            </div>
            <div className='form-actions'>
                <div className='row'>
                    <div className="col-12 pt-4">
                        <div className="button-wrapper ">
                            <button type="button" className="btn btn-ouline" onClick={(e) => props.setFormCount(1)} >Back</button>
                            <button type="button" className="btn btn-primary" onClick={handleSubmit}>Next</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PersonalTwo;